import React from 'react'
import { useNavigate } from 'react-router'

import { showToast } from '@ui/components/elements/ToastManager/ToastManager'
import { useAuth } from '@ui/providers/AuthProvider'

export const Profile = () => {
  const { currentMember, currentOrganization } = useAuth()
  const auth = useAuth()

  const navigate = useNavigate()

  const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()
    auth.signout((err: unknown) => {
      if (err) {
        showToast.error((err as Error)?.message || 'An error occurred. Please try again.')
      } else {
        navigate('/login')
      }
    })
  }

  return (
    <>
      <div className="h-full overflow-y-auto p-4">
        <div className="px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">User Information</h3>
        </div>
        <div className="mt-6 border-t border-gray-100">
          <dl className="divide-y divide-gray-100">
            <pre>{JSON.stringify(currentMember, null, 2)}</pre>
            <pre>{JSON.stringify(currentOrganization, null, 2)}</pre>
          </dl>
        </div>
        <button
          type="button"
          onClick={onClick}
          className="rounded-md bg-primary-400 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
          Logout
        </button>
      </div>
    </>
  )
}
